import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MessageService } from "src/services/message/message.service";
import { signUpForm } from "./sign-up.form";
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { AuthService } from "src/services/auth/auth.service";
import { MenuController } from "@ionic/angular";
import { passwordConfirmationValidator, phoneValidator } from "src/services/utils/form.validators";
import { PlanUniqueId } from "../../../../../../services/subscription-type/subscription-type.interface";
import { LoginService } from "../../../../../../services/auth/login.service";
import { LoadingService } from "../../../../../../services/loading/loading.service";

export interface SignUpEvent {
  referralCode: string;
}

@Component({
  selector: "rc-sign-up-form",
  templateUrl: "./sign-up-form.component.html",
  styleUrls: ["./sign-up-form.component.scss"],
  standalone: false,
})
export class SignUpFormComponent implements OnInit {
  @Input() public selectedPlanId: PlanUniqueId;

  @Output() onSuccess = new EventEmitter<SignUpEvent | undefined>();

  public formFields = signUpForm;
  public signUpForm: FormGroup;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly loadingService: LoadingService,
    private readonly loginService: LoginService,
    private readonly menu: MenuController,
    private readonly messageService: MessageService,
  ) {
    this.signUpForm = this.formBuilder.group({
      [this.formFields.confirmPassword]: new FormControl(
        "",
        Validators.compose([
          (control: AbstractControl) => Validators.required(control),
          (control: AbstractControl) =>
            passwordConfirmationValidator(control, this.signUpForm?.get(this.formFields.password)?.value),
        ]),
      ),
      [this.formFields.email]: new FormControl(
        "",
        Validators.compose([
          (control: AbstractControl) => Validators.required(control),
          (control: AbstractControl) => Validators.email(control),
        ]),
      ),
      [this.formFields.firstName]: new FormControl(
        "",
        Validators.compose([(control: AbstractControl) => Validators.required(control)]),
      ),
      [this.formFields.lastName]: new FormControl(
        "",
        Validators.compose([(control: AbstractControl) => Validators.required(control)]),
      ),
      [this.formFields.telephone]: new FormControl(
        "",
        Validators.compose([
          (control: AbstractControl) => Validators.required(control),
          (control: AbstractControl) => phoneValidator(control),
        ]),
      ),
      [this.formFields.password]: new FormControl(
        "",
        Validators.compose([(control: AbstractControl) => Validators.required(control), Validators.minLength(8)]),
      ),
    });
  }

  async ngOnInit(): Promise<void> {
    await this.menu.enable(false);
  }

  public async registerWithEmail(): Promise<void> {
    const data = this.signUpForm.value;

    await this.loadingService.wrapInLoading(async () => {
      try {
        await this.loginService.registerWithEmail(
          data.email,
          data.password,
          data.firstName,
          data.lastName,
          data.telephone,
        );
        this.onSuccess.emit();
      } catch (error) {
        await this.handleLoginErrors(error);
      }
    });
  }

  private async handleLoginErrors(error: any) {
    await this.messageService.presentErrorToast(await AuthService.getErrorMessageToDisplay(error));
  }
}
